import { render, staticRenderFns } from "./inputTemplate.vue?vue&type=template&id=584ce9c0&"
import script from "./inputTemplate.vue?vue&type=script&lang=js&"
export * from "./inputTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inputTemplate.vue"
export default component.exports